/**
 * revertNumber utility - reverts number from negative to positive or positive to negative
 *
 * @param {Number} number - number to be reverted
 * @return {Number} number - reverted number
 *
 * @example
 * const reverted = revertNumber(-5); // returns 5
 * const reverted = revertNumber(5); // returns -5
 */
export const revertNumber = (number = 0): number => -number;
